import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingDotsModule, PeekModule } from '../../core-ui';
import { PageLayoutsModule } from '../../page-layouts';
import { AccountBillingAchPanelComponent } from './account-billing-ach-panel/account-billing-ach-panel.component';
import { AccountBillingCheckPanelComponent } from './account-billing-check-panel/account-billing-check-panel.component';
import { AccountBillingContactComponent } from './account-billing-contact-panel.component';
import { AccountBillingCreditCardPanelComponent } from './account-billing-credit-card-panel/account-billing-credit-card-panel.component';
import { AccountBillingDetailComponent } from './account-billing-detail.component';
import { AccountBillingManagerPageComponent } from './account-billing-manager.page';
import { AccountBillingWirePanelComponent } from './account-billing-wire-panel/account-billing-wire-panel.component';
import { AccountBillingPaymentDetailsComponent } from './account-billling-payment-details.component';

@NgModule({
    declarations: [
        AccountBillingManagerPageComponent,
        AccountBillingContactComponent,
        AccountBillingPaymentDetailsComponent,
        AccountBillingDetailComponent,
        AccountBillingAchPanelComponent,
        AccountBillingWirePanelComponent,
        AccountBillingCheckPanelComponent,
        AccountBillingCreditCardPanelComponent
    ],
    imports: [CommonModule, PageLayoutsModule, PeekModule, LoadingDotsModule]
})
export class AccountBillingManagerModule {}
